





































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import {
  ReduceTicketReq
} from "@/pbjs/external/ticket/ticket_pb";
import { ApplyReducePenaltyFieldDetail } from "@/pbjs/xcommon/core_pb";
import { ticketClient } from "@/api";
import { localGet, setMetaData, timeFormat } from "@/utils";
import { setCommon, handleResponse, errorMsg } from "@/utils/request";

@Component({
  name: "newOrder"
})
export default class CombinationProperty extends Vue {
  @Prop() ticketData!: any;
  @Provide() private penaltyData: any = [];
  @Provide() private penaltyFormList: any = [];
  @Provide() private penaltyFormFillinList: any[] = [];
  @Provide() private isReduceTicketDone: boolean = false;
  @Provide() private penaltyForm: any = {
    interest: null,
    penalty: null,
    reason: ""
  };
  @Provide() private showTimesTips: any = {
    showlefttotaltips: null,
    lefttotalgroup: "",
    lefttotalstaff: ""

  };//减免次数展示

  private created() {
    this.reduceTicket();
  }

  private resetForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.resetFields();
  }

  private closeDialog() {
    this.$emit("showDiffTypeDialog", 0);
  }

 

  private reduceTicketFuc(data: any) {
    this.penaltyData = data.detailList;
    this.penaltyFormList = data.fieldsList;
    // this.penaltyFormList = [{
    //   displayname: "hello",
    //   fieldname: "value"
    // }];
    this.penaltyFormFillinList = this.penaltyFormList.map((item: any) => {
      let obj = {} as any;
      obj.displayname = item.displayname;
      obj.fieldname = item.fieldname;
      obj.fieldvalue = "";
      return obj;
    });

    this.showTimesTips = {
      showlefttotaltips: data.showlefttotaltips,
      lefttotalgroup: data.lefttotalgroup,
      lefttotalstaff: data.lefttotalstaff
    }
    console.log(this.penaltyFormFillinList, "penaltyFormFillinList");
    // [
    //   {
    //     label1: this.$t('ticket.GracePeriodInterest'),
    //     value1: data.graceperiodinterest,
    //     label2: this.$t('ticket.ActualInterestPaidDuringGracePeriod'),
    //     value2: data.graceperiodinterestpayed,
    //     label3: this.$t('ticket.GracePeriodInterestRemissiond'),
    //     value3: data.graceperiodinterestreduced,
    //     label4: this.$t('ticket.RemainingDeductibleInterestFromTheGracePeriod'),
    //     value4: data.graceperiodinterest - data.graceperiodinterestpayed
    //   },
    //   {
    //     label1: this.$t('ticket.PenaltyAndExtraFeesThatShouldBePaid'),
    //     value1: data.penalty,
    //     label2: this.$t('ticket.PenaltyInterestActuallyPaid'),
    //     value2: data.penaltypayed,
    //     label3: this.$t('ticket.RemissiondPenaltyInterest'),
    //     value3: data.penaltyreduced,
    //     label4: this.$t('ticket.TheRemainingPenaltyInterestCanBeRemission'),
    //     value4: data.penalty - data.penaltypayed - data.penaltyreduced
    //   }
    // ];
  }
  private reduceTicket() {
    let request: any = new ReduceTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(this.ticketData.itemid);
    request.setTicketid(this.ticketData.id);
    console.log(request, this.ticketData, "---reduceTicket");
    ticketClient.reduceTicket(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          console.log(JSON.stringify(data), "reduce====================>");
          let _fuc = this.reduceTicketFuc;
          handleResponse(data, _fuc);
          // if (!data.commonout || (data.commonout.code == 0)) {
          //   this.penaltyData = [
          //     {
          //       label1: this.$t('ticket.GracePeriodInterest'),
          //       value1: data.graceperiodinterest,
          //       label2: this.$t('ticket.ActualInterestPaidDuringGracePeriod'),
          //       value2: data.graceperiodinterestpayed,
          //       label3: this.$t('ticket.GracePeriodInterestRemissiond'),
          //       value3: data.graceperiodinterestreduced,
          //       label4: this.$t('ticket.RemainingDeductibleInterestFromTheGracePeriod'),
          //       value4: data.graceperiodinterest - data.graceperiodinterestpayed
          //     },
          //     {
          //       label1: this.$t('ticket.PenaltyAndExtraFeesThatShouldBePaid'),
          //       value1: data.penalty,
          //       label2: this.$t('ticket.PenaltyInterestActuallyPaid'),
          //       value2: data.penaltypayed,
          //       label3: this.$t('ticket.RemissiondPenaltyInterest'),
          //       value3: data.penaltyreduced,
          //       label4: this.$t('ticket.TheRemainingPenaltyInterestCanBeRemission'),
          //       value4: data.penalty - data.penaltypayed - data.penaltyreduced
          //     }
          //   ];
          // } else {
          //   this.$message.error(data.commonout.errmsg);
          // }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private doReduceTicketFuc() {
    this.resetForm("penaltyForm");
    this.closeDialog();
    this.$message({
      type: "success",
      message: "submit successfully!"
    });
  }

  // 减免本金  拆分后接口
  private async doReduceOther () {
    console.log('enter new===>')
    this.isReduceTicketDone = true;
    let _arg: any = {
      TicketId :this.ticketData.id ,
      ItemId :this.ticketData.itemid,
      Reason :this.penaltyForm.reason,
      penaltyFormFillinList:this.penaltyFormFillinList


    };
    const { getReduceOtherReq, getReduceOtherRequest }: any = await import(
      "@/request/reducePrincipalAndOther"
    );
    let res = await getReduceOtherRequest.handleHttp(getReduceOtherReq(_arg), this);
    console.log('res===>',res)
    if (res && res.right) {
      this.isReduceTicketDone = false
      this.doReduceTicketFuc()
    }else{
    this.isReduceTicketDone = false
    }
  }
}
